<div class="pt-1" data-testing-id="rating-stars-field">
  @for (fill of stars; track fill; let i = $index) {
  <button
    type="button"
    class="text-muted btn btn-link btn-link-action"
    [title]="'product.review.rating.tooltip' | translate : { '0': i + 1 }"
    (click)="setStars(i + 1)"
  >
    <ish-product-rating-star [filled]="fill" />
  </button>
  }
</div>
